import { SVGProps } from 'react';

const CircleArrow = ({
  width = 37,
  height = 36,
  circleFill = "white",
  arrowFill = "#2A2A2A",
  strokeColor = "#2A2A2A",
  strokeWidth = 1,
  ...otherProps
}: SVGProps<SVGSVGElement> & {
  circleFill?: string;
  arrowFill?: string;
  strokeColor?: string;
  strokeWidth?: number;
}) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 40 40" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...otherProps}
  >
    <circle 
      cx="20" 
      cy="20" 
      r="16" 
      fill={circleFill}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M19.3086 13.1213L21.43 11L30.5512 20.1212L30.5374 20.135L30.5528 20.1504L21.4297 29.2734L19.3084 27.1521L24.8004 21.6602L9.99902 21.6602V18.6602L24.8475 18.6602L19.3086 13.1213Z" 
      fill={arrowFill}
    />
  </svg>
);

export default CircleArrow; 